/* src/app/releasenotes/releasenotes.component.css */
/*# sourceMappingURL=releasenotes.component-LJTGYQBC.css.map */
